module.exports = __webpack_public_path__ + "f9f5cc4767994952831b5d035962e43d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Emerald.png
// module id = 775
// module chunks = 0